/**
 * Output size/quality of picked photos (longest side in px, JPEG quality 0-100). Regular photos
 * are kept small: smaller uploads and less WebView memory per preview. Nameplate photos keep more
 * detail because they are cropped afterwards and their text must stay readable for OCR.
 */
export const PHOTO_MAX_DIMENSION = 1920;
export const PHOTO_QUALITY = 80;
export const NAMEPLATE_MAX_DIMENSION = 2560;
export const NAMEPLATE_QUALITY = 80;
